import React from "react";
import { Container} from "stories/layout";

const PageContainer = ({ children, className, bgColor = "bg-white" }) => {
  const resolvedClass = [ "page_container", bgColor, "p-2", className ].filter(Boolean).join(" ");
  return (
    <div className={resolvedClass}>
    {children}
    </div>
  )
}

export default PageContainer;